module.exports = __webpack_public_path__ + "static/media/09.microsoft-excel.e4fe8e07.svg";